import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";
import { Device } from "../../types/device/device.type";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const deviceApi = createApi({
  reducerPath: "deviceApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Device", "Devices"],

  endpoints: (builder) => ({
    // Get all devices
    getDevices: builder.query<any[], { page?: number; limit?: number }>({
      query: ({ page, limit } = {}) => ({
        url: `${ApiEndpoints.getAllDevices}?page=${page}&limit=${limit}`,
        method: "GET",
      }),
      // Just return the raw results array, no transform here
      transformResponse: (res: any) =>
        Array.isArray(res?.results) ? res.results : [],
      providesTags: ["Devices"],
    }),

    // Get device by ID
    getDeviceById: builder.query<Device, string>({
      query: (deviceId) => ({
        url: `${ApiEndpoints.getDeviceById}/${deviceId}`,
        method: "GET",
      }),
      transformResponse: (res: any): Device => {
        const device = res?.result ?? res?.results ?? res ?? {};
        return {
          id: String(device._id ?? device.id ?? ""),
          code: device.code ?? "",
          name: device.name ?? "",
          model: device.model ?? "",
          type: device.type ?? "ALL",
          subscriber: device.subscriber ?? "",
          organisation: device.organisation ?? "",
          gym: device.gym ?? "",
          lastUsed: device.lastUsed ?? "",
          lastSync: device.lastSync ?? "",
          isActive: !!device.isActive,
          activeAt: device.activeAt ?? "",
          active: {
            session: device.active?.session ?? "",
            schedule: device.active?.schedule ?? "",
            screen: device.active?.screen ?? "",
          },
          status: device.status ?? "",
        };
      },
      providesTags: (_result, _error, deviceId) => [
        { type: "Device", id: deviceId },
      ],
    }),

    // ...existing code...
  }),
});

export const { useGetDevicesQuery, useGetDeviceByIdQuery } = deviceApi;
